/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Lazy loading of the component PageAuth
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.0
 */
import loadable from '../../utils/loadable';

/**
 * @description Lazy loading of a component
 * @class PageAuthLocale
 */
export default loadable(() => import(/* webpackChunkName: "PageAuth" */ './PageAuth'), undefined);
